import Vue from 'vue'
import microApp from '@micro-zoe/micro-app'

microApp.start({
    // globalAssets: {
    //     // js: ['https://tj-sqet.btzh.net:4443/js.arcgis.com/arcgis4.16/esri/portal/support/geometryServiceUtils.js'],
    //     // css: ['https://tj-sqet.btzh.net:4443/js.arcgis.com/arcgis4.16/esri/css/main.css']
    // },
    // lifeCycles: {
    //     created () {
    //         // 微服务加载子系统脚本文件 短时间内模块化无值，故预先初始化地图脚本
    //         console.log('created')
    //     },
    //     beforemount () {
    //         console.log('beforemount')
    //     },
    //     mounted () {
    //         console.log('mounted')
    //     },
    //     unmount () {
    //         console.log('unmount')
    //     },
    //     error () {
    //         console.log('error')
    //     }
    // }
})

Vue.microApp = Vue.prototype.$microApp = microApp
